// Logo de la herramienta (Palacete) para el centro del QR.
//
// Slot listo para el futuro: hoy es null (no se muestra la opción "Logo de la
// herramienta" hasta que haya un asset real). Para activarlo basta con poner aquí
// la URL pública del logo — el resto de la lógica de render ya lo soporta.
export const PLATFORM_LOGO_URL: string | null = null;

const LIGHT = /^#([0-9a-f]{3}|[0-9a-f]{6})$/i;

/** Luminancia relativa (0 = negro, 1 = blanco) de un color hex. */
export function relativeLuminance(hex: string): number {
  if (!LIGHT.test(hex)) return 0;
  let h = hex.slice(1);
  if (h.length === 3) h = h.split('').map((ch) => ch + ch).join('');
  const r = parseInt(h.slice(0, 2), 16) / 255;
  const g = parseInt(h.slice(2, 4), 16) / 255;
  const b = parseInt(h.slice(4, 6), 16) / 255;
  const lin = (v: number) => (v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4));
  return 0.2126 * lin(r) + 0.7152 * lin(g) + 0.0722 * lin(b);
}

/** Oscurece un color hex un factor [0..1] (0.6 = 60% del brillo). */
export function darken(hex: string, factor = 0.6): string {
  if (!LIGHT.test(hex)) return hex;
  let h = hex.slice(1);
  if (h.length === 3) h = h.split('').map((ch) => ch + ch).join('');
  const ch = (i: number) => Math.round(parseInt(h.slice(i, i + 2), 16) * factor).toString(16).padStart(2, '0');
  return `#${ch(0)}${ch(2)}${ch(4)}`;
}

/**
 * Devuelve un color con contraste suficiente para los módulos del QR sobre
 * fondo blanco. Si el color es demasiado claro (lectura comprometida), cae a negro.
 */
export function readableModuleColor(hex: string | null | undefined): string {
  if (!hex || !LIGHT.test(hex)) return '#000000';
  return relativeLuminance(hex) > 0.5 ? darken(hex, 0.45) : hex;
}
